export const getRoleFilter = state => state.roleAdmin.filter
